Promise.all([import('@meteora-digital/tween')]).then(_ref => {
  let [moduleTween] = _ref;
  const TweenController = moduleTween.default;

  // Watch for new number blocks
  DomObserver.observe('.js-default-number', blocks => {
    blocks.forEach(block => {
      // Store all the items in the block
      const items = [...block.querySelectorAll('.js-default-number__item')];

      // Loop all the items
      items.forEach(item => {
        // Find the number
        const number = item.querySelector('.js-default-number__number');
        // Get the value of the number
        const value = parseInt(number.textContent);

        // Make sure the number is a number
        if (isNaN(value)) return;

        // Lock the width of the number
        number.style.width = `${number.clientWidth}px`;

        // Set the number to 0
        number.textContent = 0;

        // Create a new tween controller
        const Controller = new TweenController();

        // Observe when the item comes into view
        const Observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // Disconnect the observer
              Observer.disconnect();
              // Tween the number
              setTimeout(() => {
                Controller.tween({
                  from: 0,
                  to: value
                }, n => number.textContent = parseInt(n), 2000);
              }, 500);
            }
          });
        });

        // When the animation ends, ensure the number is the correct value
        Controller.on('end', () => {
          // Set the number to the correct value
          number.textContent = value;
          // Unlock the width of the number
          number.style.width = '';
        });

        // Observe the item
        Observer.observe(item);
      });
    });
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});